<script>
export default {
  props: {
    optIn: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      optInData: this.optIn,
    }
  },
  methods: {
    optInName(item) {
      if (this.optInData.label) {
        return this.optInData.label
      }

      if (this.optInData.indexOf('tld_') === -1) {
        return item
      }

      let tld = this.optInData.replace('tld_', '')
      if (tld === 'uk') {
        tld = 'co.uk'
      }

      const dictionary = {
        'co.uk': '🇬🇧 UK',
        fr: '🇫🇷 French',
        de: '🇩🇪 German',
        ca: '🇨🇦 Canadian',
      }

      return `${dictionary[tld] || `.${tld}`} Retailers`
    },
    optInHint(item) {
      return item.hint
    },
  },
}
</script>

<template>
  <div :class="$style.tagLabel">
    {{ optInName(optInData) }}
    <p v-if="optInData.hint" :class="$style.tagHint">{{
      optInHint(optInData)
    }}</p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.tagLabel {
  justify-self: flex-start;
}

.tagHint {
  font-size: 10px;
}
</style>
